var DSForms = DSForms || {};

defineDs('DanskeSpil/Domain/Feature.Components/Scripts/FormsModule.js', [], function () {
  const inputFocusClasses = ['top-2', 'pt-4', 'ml-1', 'text-size-input-select-label-small', 'leading-input-select-label-small', 'text-size-text-area-label-small', 'leading-text-area-label-small'];
  const inputBlurClasses = ['top-14', 'pt-1', 'text-size-input-select-label-large', 'leading-input-select-label-large', 'text-size-text-area-label-large', 'leading-text-area-label-large'];
  const inputErrorClasses = ['border-width-text-area-error', 'border-text-area-error', 'text-text-area-error', 'bg-text-area-error'];
  const checkboxFocusClasses = ['border-checkbox-focused', 'bg-checkbox-focused', 'border-radiobutton-focused', 'bg-radiobutton-focused'];
  const checkboxErrorClasses = ['border-checkbox-error', 'bg-checkbox-error', 'border-radiobutton-error', 'bg-radiobutton-error'];

  DSForms.onFocus = (input) => {
    const parent = input.parentElement;
    parent.querySelector('label')?.classList.remove(...inputBlurClasses);
    parent.querySelector('label')?.classList.add(...inputFocusClasses);
  };

  DSForms.onBlur = (input) => {
    const parent = input.parentElement;
    if (input.value) return;
    parent.querySelector('label')?.classList.remove(...inputFocusClasses);
    parent.querySelector('label')?.classList.add(...inputBlurClasses);
  };

  DSForms.onInvalid = (input, e) => {
    e.preventDefault();
    input.classList.add(...inputErrorClasses);
    const parent = input.parentElement;

    parent.querySelector('p.text-text-area-error-text')?.classList.remove('hidden');
    parent.querySelector('p.text-input-select-error-text')?.classList.remove('hidden');
    parent.querySelector('p.text-text-area-helper')?.classList.add('hidden');
    parent.querySelector('p.text-input-select-helper')?.classList.add('hidden');

    parent.querySelector('label.text-text-area-default-label')?.classList.add('text-text-area-error-text');
    parent.querySelector('label.text-input-select-default-label')?.classList.add('text-input-select-error-text');

    if (input.type === 'radio' || input.type === 'checkbox') {
      parent.querySelector('* > div')?.classList.add(...checkboxErrorClasses);
      parent.querySelector('p.text-checkbox-helper')?.classList.add('text-checkbox-error');
      parent.querySelector('p.text-radiobutton-helper')?.classList.add('text-radiobutton-error');
    }
  };

  DSForms.onChange = (input) => {
    input.classList.remove(...inputErrorClasses);
    const parent = input.parentElement;

    if (input.value) {
      parent.querySelector('label')?.classList.remove(...inputBlurClasses);
      parent.querySelector('label')?.classList.add(...inputFocusClasses);
    }

    parent.querySelector('p.text-text-area-error-text')?.classList.add('hidden');
    parent.querySelector('p.text-input-select-error-text')?.classList.add('hidden');
    parent.querySelector('p.text-text-area-helper')?.classList.remove('hidden');
    parent.querySelector('p.text-input-select-helper')?.classList.remove('hidden');

    parent.querySelector('label.text-text-area-default-label')?.classList.remove('text-text-area-error-text');
    parent.querySelector('label.text-input-select-default-label')?.classList.remove('text-input-select-error-text');

    if (input.type === 'radio') {
      parent.closest('.flex.flex-col').querySelectorAll('label > div')?.forEach((element) => {
        const elementInput = element.querySelector('input');
        if (elementInput.value !== input.value) {
          element.querySelector('* > div')?.classList.remove('border-radiobutton-focused', 'bg-radiobutton-focused');
          parent.querySelector('svg')?.classList.add('hidden');
          element.querySelector('* > div')?.classList.remove('border-radiobutton-error', 'bg-radiobutton-error');
          element.querySelector('p.text-checkbox-helper')?.classList.remove('text-checkbox-error');
          element.querySelector('p.text-radiobutton-helper')?.classList.remove('text-radiobutton-error');
        }
      });
    }

    if (input.type === 'radio' || input.type === 'checkbox') {
      if (input.checked === true) {
        parent.querySelector('* > div')?.classList.add(...checkboxFocusClasses);
      } else {
        parent.querySelector('* > div')?.classList.remove(...checkboxFocusClasses);
      }

      parent.querySelector('svg')?.classList.toggle('hidden');
      parent.querySelector('* > div')?.classList.remove(...checkboxErrorClasses);
      parent.querySelector('p.text-checkbox-helper')?.classList.remove('text-checkbox-error');
      parent.querySelector('p.text-radiobutton-helper')?.classList.remove('text-radiobutton-error');
    }
  };

  const formToJSON = (form) => {
    const formData = new FormData(form);
    const json = {};
    formData.forEach((value, key) => {
      if (json[key]) {
        if (!Array.isArray(json[key])) {
          json[key] = [json[key]];
        }

        json[key].push(value);
      } else json[key] = value;
    });

    return JSON.stringify(json);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    form.querySelector('span.text-input-select-default-text').classList.add('hidden');
    form.querySelector('span.text-input-select-error-text').classList.add('hidden');
    fetch(form.action, {
      method: 'POST',
      body: formToJSON(form)
    }).then((response) => {
      if (!response.ok) {
        form.querySelector('span.text-input-select-error-text').classList.remove('hidden');
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const confirmationLink = form.dataset.confirmationLink;
      if (confirmationLink) {
        window.location.href = confirmationLink;
        return;
      }

      form.querySelector('span.text-input-select-default-text').classList.remove('hidden');
      return response.body;
    }).catch((error) => {
      console.error(error);
    });
  };

  document.querySelectorAll('.js-forms-module')?.forEach((elem) => elem.addEventListener('submit', handleSubmit, false));
});
